export const pages = {
	'linkOutGR': { id: 'linkOutGR', page: 'text', getter: () => import(/* webpackChunkName: 'text' */ 'components/bolt/text/text') }
};
export const sections = [

];
